import { DevicePermission } from 'console/device/device_ts';
import { SocketsTab } from './tab';
import { DefaultTabKey } from 'console/shared/content/tab/types';
import { LegacyDevice } from 'console/device/device';
import { Capability } from 'console/device/device-capability';
export const sockets_tab_definition = {
    key: DefaultTabKey.sockets,
    title: 'Управление',
    iconclass: 'ui-icon-tab-state',
    // icon: <CustomIcon Icon={icon.render} width={26} height={26} />,
    should_appear_depends_on: ['capabilities', 'z3k_config'],
    should_appear: (_device, _account, r_device, r_account) => {
        if (LegacyDevice.has_access(r_account.id, r_device, DevicePermission.control)) {
            if (LegacyDevice.has_capability(r_device?.capabilities, Capability.has_z3k_settings)) {
                if (r_device.device_type?.code.includes('SOCKETS_03')) {
                    return true;
                }
            }
        }
        return false;
    },
    render: SocketsTab,
};
